module.exports = __webpack_public_path__ + "static/media/selected-line-circle-icon.b937b1bc.svg";